import React, { memo, lazy, useState, useCallback, Fragment, Suspense } from 'react';
import type { OperationalQuotasProps } from 'operationalQuotas/OperationalQuotas';

import {
    OperationalQuotasEvents,
    type OperationalQuotasModalOptions,
} from '../../../utils/events/operationalQuotas.events';
import { useEvent } from '../../common/hooks/useEvent.hook';

const FederatedOperationalQuotas = lazy(() => import('operationalQuotas/OperationalQuotas'));

export const OperationalQuotas = () => {
    const [config, setConfig] = useState<OperationalQuotasProps | null>(null);

    const hideModalHandler = () => {
        setConfig(null);
    };

    const showModalHandler = useCallback(
        (e: CustomEvent<OperationalQuotasModalOptions>) => {
            setConfig({
                baseUrl: window.ts.globals.TQS_ALL_PROJECTS_URL,
                initialDataUrl: window.ts.globals.TIM_BASEAPI_URL,
                translationUrl: window.ts?.globals?.OPERATIONAL_QUOTAS_TRANSLATION_URL,
                ...e?.detail,
                onSave: (...args) => {
                    e?.detail?.onSave?.(...args);
                    hideModalHandler();
                },
                onClose: () => {
                    e?.detail?.onClose?.();
                    hideModalHandler();
                },
            });
        },
        [hideModalHandler]
    );

    useEvent({ name: OperationalQuotasEvents.SHOW_MODAL, handler: showModalHandler });
    useEvent({ name: OperationalQuotasEvents.HIDE_MODAL, handler: hideModalHandler });

    return config ? (
        <Suspense fallback={<Fragment />}>
            <FederatedOperationalQuotas {...config} />
        </Suspense>
    ) : null;
};

export default memo(OperationalQuotas, () => true);
